<template>
  <section class="employment-data" id="employmentDataSection">
    <div class="container">
      <h2 class="section-title">
        <span class="title-text">就业数据</span>
        <span class="title-line"></span>
      </h2>

      <!-- 数据概览卡片 -->
      <div class="data-overview">
        <el-card class="data-card">
          <div class="data-item">
            <div class="data-value">300+</div>
            <div class="data-label">已就业学员</div>
          </div>
        </el-card>

        <el-card class="data-card">
          <div class="data-item">
            <div class="data-value">¥12,800</div>
            <div class="data-label">平均起薪</div>
          </div>
        </el-card>

        <el-card class="data-card">
          <div class="data-item">
            <div class="data-value">96.8%</div>
            <div class="data-label">就业率</div>
          </div>
        </el-card>

        <el-card class="data-card">
          <div class="data-item">
            <div class="data-value">281</div>
            <div class="data-label">总课时</div>
          </div>
        </el-card>
      </div>

      <!-- 图表数据 -->
      <div class="charts-container">
        <el-card class="chart-card">
          <div class="chart-title">薪资分布</div>
          <el-row :gutter="10" class="chart-wrapper">
            <el-col :span="24">
              <div class="chart-content">
                <canvas id="salaryChart"></canvas>
              </div>
            </el-col>
          </el-row>
        </el-card>

        <el-card class="chart-card">
          <div class="chart-title">就业行业分布</div>
          <el-row :gutter="10" class="chart-wrapper">
            <el-col :span="24">
              <div class="chart-content">
                <canvas id="industryChart"></canvas>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted, nextTick } from 'vue'
import { ElCard, ElRow, ElCol } from 'element-plus'
// 导入Chart.js及所需控制器/组件
import {
  Chart,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  BarController,
  DoughnutController
} from 'chart.js'

// 注册Chart.js必要组件
Chart.register(
    ArcElement,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    BarController,
    DoughnutController
)

// 安全获取Canvas元素并初始化图表
const initChart = (chartId, config) => {
  const element = document.getElementById(chartId)
  if (!element) {
    console.error(`未找到ID为${chartId}的Canvas元素`)
    return null
  }

  const context = element.getContext('2d')
  if (!context) {
    console.error(`无法获取${chartId}的2d上下文`)
    return null
  }

  return new Chart(context, config)
}

// 页面挂载后渲染图表
onMounted(() => {
  // 使用nextTick确保DOM完全渲染
  nextTick(() => {
    // 1. 薪资分布柱状图
    initChart('salaryChart', {
      type: 'bar',
      data: {
        labels: ['8k以下', '8k-10k', '10k-15k', '15k-20k', '20k以上'],
        datasets: [{
          label: '学员数量',
          data: [16, 65, 111, 74, 34],
          backgroundColor: [
            'rgba(255, 99, 132, 0.7)',
            'rgba(255, 159, 64, 0.7)',
            'rgba(255, 205, 86, 0.7)',
            'rgba(75, 192, 192, 0.7)',
            'rgba(54, 162, 235, 0.7)'
          ],
          borderColor: [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)'
          ],
          borderWidth: 1,
          borderRadius: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            title: { display: true, text: '人数' }
          }
        },
        plugins: {
          legend: {
            display: false
          }
        }
      }
    })

    // 2. 就业行业分布环形图
    initChart('industryChart', {
      type: 'doughnut',
      data: {
        labels: ['智能座舱域', '智能驾驶域', '车身域', '车载网络测试', 'OTA升级', 'Tbox车联网'],
        datasets: [{
          data: [28, 25, 18, 15, 8, 6],
          backgroundColor: [
            'rgba(54, 162, 235, 0.7)',
            'rgba(75, 192, 192, 0.7)',
            'rgba(255, 205, 86, 0.7)',
            'rgba(255, 159, 64, 0.7)',
            'rgba(153, 102, 255, 0.7)',
            'rgba(255, 99, 132, 0.7)'
          ],
          borderColor: [
            'rgb(54, 162, 235)',
            'rgb(75, 192, 192)',
            'rgb(255, 205, 86)',
            'rgb(255, 159, 64)',
            'rgb(153, 102, 255)',
            'rgb(255, 99, 132)'
          ],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '60%',
        plugins: {
          legend: {
            position: 'right',
            labels: {
              padding: 15
            }
          }
        }
      }
    })
  })
})
</script>

<style scoped>
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

.section-title {
  text-align: center;
  margin-bottom: 40px;
  position: relative;
  padding-bottom: 15px;
}

.title-text {
  font-size: 28px;
  color: #333;
  font-weight: bold;
}

.title-line {
  display: block;
  width: 60px;
  height: 3px;
  background-color: #ff6700;
  margin: 10px auto 0;
  border-radius: 1.5px;
}

/* 就业数据特有样式 */
.employment-data {
  padding: 60px 0;
  background-color: #fff;
}

.data-overview {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 50px;
}

.data-card {
  text-align: center;
  padding: 20px 10px;
  background-color: #f9f9f9;
  border: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
}

.data-value {
  font-size: 32px;
  font-weight: bold;
  color: #ff6700;
  margin-bottom: 10px;
  line-height: 1.2;
}

.data-label {
  font-size: 16px;
  color: #666;
}

.charts-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

.chart-card {
  border: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 20px;
  border-radius: 8px;
}

.chart-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

.chart-wrapper {
  width: 100%;
}

.chart-content {
  width: 100%;
  height: 300px; /* 固定图表高度 */
}

/* 平板端适配 */
@media (max-width: 992px) {
  .charts-container {
    grid-template-columns: 1fr;
  }

  .data-overview {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* 手机端适配 */
@media (max-width: 768px) {
  .section-title {
    margin-bottom: 30px;
  }

  .title-text {
    font-size: 24px;
  }

  .data-value {
    font-size: 26px;
  }

  .data-label {
    font-size: 14px;
  }

  .chart-card {
    padding: 16px;
  }

  .chart-title {
    font-size: 16px;
    margin-bottom: 12px;
  }
}

@media (max-width: 576px) {
  .data-overview {
    grid-template-columns: 1fr;
  }

  .section-title {
    margin-bottom: 30px;
  }

  .title-text {
    font-size: 24px;
  }

  .data-value {
    font-size: 28px;
  }

  .chart-content {
    height: 250px;
  }

  .employment-data {
    padding: 40px 0;
  }
}
</style>
